import React, { Component, ReactNode } from "react";

import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";

import { withStyles } from "@material-ui/core/styles";
import { WithStyles, createStyles } from "@material-ui/core";
import { Theme } from "@material-ui/core/styles/createMuiTheme";

import { Collapse, Paper, Typography } from "@material-ui/core";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      position: "relative",
    },
    header: {
      padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 2}px`,
      "& h3": {
        margin: 0,
        color: "#333",
        fontSize: 16,
        fontStyle: "normal",
        fontFamily: '"Nunito", sans-serif',
        fontWeight: 600,
      },
    },
    body: {
      borderTop: "1px solid #E4E4E4",
      padding: `${theme.spacing.unit}px ${theme.spacing.unit * 2}px ${theme
        .spacing.unit * 2}px`,
    },
    iconArrow: {
      fontSize: "28px",
      position: "absolute",
      top: 14,
      right: "6px",
    },
  });

interface MyPATCollapseProps extends WithStyles<typeof styles> {
  defaultState: boolean;
  title: String;
  customTitle: ReactNode;
  children: ReactNode;
  isShow: boolean;
}

interface MyPATCollapseState {
  isOpen: boolean;
}

class MyPATCollapse extends Component<MyPATCollapseProps, MyPATCollapseState> {
  constructor(props: MyPATCollapseProps, state: MyPATCollapseState) {
    super(props);

    this.state = {
      isOpen: true,
    };

    if (props.defaultState == false) {
      this.setState({ isOpen: false });
    }

    this.toggleState = this.toggleState.bind(this);
  }

  toggleState() {
    const { isShow } = this.props;
    isShow
      ? this.setState({ isOpen: true })
      : this.setState({ isOpen: !this.state.isOpen });
  }

  render() {
    const { classes } = this.props;

    return (
      <Paper className={classes.root} elevation={0}>
        <div className={classes.header} onClick={this.toggleState}>
          {this.props.title ? (
            <Typography component="h3">{this.props.title}</Typography>
          ) : (
            this.props.customTitle
          )}
          {this.state.isOpen ? (
            <ArrowDropDownIcon className={classes.iconArrow} />
          ) : (
            <ArrowDropUpIcon className={classes.iconArrow} />
          )}
        </div>

        <Collapse in={this.state.isOpen}>
          <div className={classes.body}>{this.props.children}</div>
        </Collapse>
      </Paper>
    );
  }
}

// @ts-ignore
export default withStyles(styles)(MyPATCollapse);
